













import { compile } from 'path-to-regexp';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteRecord, Route } from 'vue-router';

@Component({
	name: 'Breadcrumb'
})
/** breadcrumb */
export default class BreadCrumb extends Vue {
	private breadcrumbs: RouteRecord[] = [];

	/** watch route */
	@Watch('$route')
	private onRouteChange(route: Route): any {
		// if you go to the redirect page, do not update the breadcrumbs
		if (route.path.startsWith('/redirect/')) {
			return;
		}

		this.getBreadcrumb();
	}

	/** hook */
	public created(): any {
		this.getBreadcrumb();
	}

	/** 获取面包屑 */
	private getBreadcrumb(): any {
		let matched: any = this.$route.matched.filter((item: any): any => item.meta && item.meta.title);
		const first: any = matched[0];

		if (!this.isDashboard(first)) {
			const matchArray: Array<any> = [
				{
					path: '/home/index',
					meta: {
						title: 'dashboard'
					}
				}
			];

			matched = matchArray.concat(matched);
		}

		this.breadcrumbs = matched.filter((item: any): any => item.meta && item.meta.title && item.meta.breadcrumb !== false);
	}

	/** dashboard判断 */
	private isDashboard(route: RouteRecord): any {
		const name: any = route && route.name;

		if (!name) {
			return false;
		}

		return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase();
	}

	/**
	 * 面包屑:id 方式支持:
	 * To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
	 */
	private pathCompile(path: string): any {
		const { params }: any = this.$route;
		const toPath: any = compile(path);

		return toPath(params);
	}

	/** 点击链接跳转 */
	private handleLink(item: any): any {
		// const { redirect, path }: any = item;
		// if (redirect) {
		// 	this.$router.push(redirect)['catch']((err: any): any => {
		// 		console.warn(err);
		// 	});
		// 	return;
		// }
		// this.$router.push(this.pathCompile(path))['catch']((err: any): any => {
		// 	console.warn(err);
		// });
	}
}
